import React from 'react';
import { Section } from './ui/Section';
import { FileText, MessageSquare, CheckSquare, Layout } from 'lucide-react';
export function Deliverables() {
  const items = [{
    icon: <Layout className="w-8 h-8 text-accent-yellow" data-id="element-12" />,
    title: 'Estructura de Landing de 1 Página',
    desc: "Bloque por bloque con el framework '7 bloques que convierten'."
  }, {
    icon: <FileText className="w-8 h-8 text-accent-blue" data-id="element-13" />,
    title: 'Plantillas Copiables',
    desc: 'Titulares, dolor espejo y FAQs que destraban compras.'
  }, {
    icon: <CheckSquare className="w-8 h-8 text-green-500" data-id="element-14" />,
    title: "Checklist 'Listo en 90 min'",
    desc: 'El paso a paso exacto para no perderte.'
  }, {
    icon: <MessageSquare className="w-8 h-8 text-purple-500" data-id="element-15" />,
    title: 'Los 3 Mensajes Día 0',
    desc: 'Texto listo para copiar: Activación, Rescate y Cierre.'
  }];
  return <Section className="bg-section" data-id="element-16">
      <h2 className="text-3xl md:text-4xl font-bold text-white text-center mb-12" data-id="element-17">
        Qué incluye (entregables concretos)
      </h2>

      <div className="grid md:grid-cols-2 gap-6" data-id="element-18">
        {items.map((item, i) => <div key={i} className="bg-primary p-8 rounded-2xl border border-white/5 hover:border-white/10 transition-all hover:-translate-y-1" data-id="element-19">
            <div className="mb-4 bg-white/5 w-16 h-16 rounded-xl flex items-center justify-center" data-id="element-20">
              {item.icon}
            </div>
            <h3 className="text-xl font-bold text-white mb-2" data-id="element-21">{item.title}</h3>
            <p className="text-text-secondary" data-id="element-22">{item.desc}</p>
          </div>)}
      </div>
    </Section>;
}